import type { AnimationProps } from 'framer-motion';
import {
  type ForwardedRef,
  forwardRef,
  type ReactElement,
  type ReactNode,
  type RefAttributes,
} from 'react';

import { Stage } from './Stage';

type ToggleStageProps<T = undefined> = {
  status: boolean;
  fallback?: ReactNode;
  children: ReactNode | ((data: NonNullable<T>) => ReactNode);
  className?: string;
  options?: AnimationProps;
  data?: T;
};

const ToggleStageComponent = <T = undefined>(
  { status, fallback, children, className, options, data }: ToggleStageProps<T>,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  return (
    <Stage>
      <Stage.Scene status={!status} className={className}>
        {fallback}
      </Stage.Scene>
      <Stage.Scene default className={className} options={options} ref={ref}>
        {typeof children === 'function'
          ? data
            ? children(data)
            : null
          : children}
      </Stage.Scene>
    </Stage>
  );
};

type ToggleStageComponentType = <T = undefined>(
  props: ToggleStageProps<T> & RefAttributes<HTMLDivElement>,
) => ReactElement | null;

export const ToggleStage = forwardRef(
  ToggleStageComponent,
) as ToggleStageComponentType;
